import Page403 from './components/403';

export default Page403;


// WEBPACK FOOTER //
// ./routes/403/index.js